import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "Test",
  props: [],
  components: {},
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      active: 0,
      sticky: true
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll: function onScroll() {
      // 记录nav的active锚点
      var navContents = document.querySelectorAll(".nav-content");
      var offsetTopArr = [];
      navContents.forEach(function (item) {
        offsetTopArr.push(item.offsetTop - 150);
      });
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      var navIndex = 0;

      for (var i = 0; i < offsetTopArr.length; i++) {
        if (scrollTop >= offsetTopArr[i]) {
          navIndex = i;
        }
      }

      this.active = navIndex; // 此处开始计算底部办理的粘性布局

      var detailMain = document.getElementById("detailMain");
      var detailMainTop = detailMain.offsetTop + detailMain.clientHeight - 20 - window.innerHeight;

      if (scrollTop < detailMainTop) {
        this.sticky = true;
      } else {
        this.sticky = false;
      }
    },
    scrollTo: function scrollTo(index) {
      var _this = this;

      // 因为第一个.nav-content是父元素的第二个子元素，第一个是p标签，并且nth-child从1开始计数，所以从2开始对应该元素锚点
      var targetOffsetTop = document.querySelector(".nav-content:nth-child(".concat(index + 2, ")")).offsetTop - 80;
      document.body.scrollTop = targetOffsetTop;
      document.documentElement.scrollTop = targetOffsetTop;
      setTimeout(function () {
        _this.active = index;
      }, 30);
    }
  },
  watch: {},
  filters: {}
};